var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

import PropTypes from 'prop-types';

var Table = function (_React$Component) {
  _inherits(Table, _React$Component);

  function Table() {
    _classCallCheck(this, Table);

    return _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
  }

  _createClass(Table, [{
    key: 'render',
    value: function render() {
      var className = 'cf-table';

      if (this.props.striped) className += ' cf-table--striped';
      if (this.props.hover) className += ' cf-table--hover';
      if (this.props.bordered) className += ' cf-table--bordered';
      if (this.props.condensed) className += ' cf-table--condensed';
      if (this.props.className.trim()) className += ' ' + this.props.className.trim();

      return React.createElement(
        'table',
        { className: className },
        this.props.children
      );
    }
  }]);

  return Table;
}(React.Component);

Table.propTypes = {
  className: PropTypes.string,
  striped: PropTypes.bool,
  hover: PropTypes.bool,
  bordered: PropTypes.bool,
  condensed: PropTypes.bool,
  children: PropTypes.node
};

Table.defaultProps = {
  className: '',
  striped: false,
  hover: false,
  bordered: true,
  condensed: false
};

export default Table;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-table/es/Table.js
// module id = 789
// module chunks = 0